import React from 'react';


const Section1 = () => {

  return (
    <section className='sc1 section'>
          <div className="sc1-container container grid">
            <div className="sc1-info">
              <h2 className='section-title'>CASA ORIGEN ECOHOTEL</h2>
              <p>Sumérgete en un entorno privilegiado donde la naturaleza y el confort se fusionan en perfecta armonía.</p>
              <p>Es una alternativa distinta, un espacio en medio de la naturaleza a las afueras de la capital de bolívar, pensado para todos los miembros de la familia que quieran alejarse del bullicio y el ajetreo de la ciudad. Fraternizar, compartir momentos en familia o simplemente dedicarse tiempo a sí mismos.
Es el lugar ideal para conectar con la naturaleza y vivir nuevas experiencias.</p>

              <div className="sc1-reserv">
                <div className="reserv-icon">
                  <i className="ri-phone-line"></i>
                </div>
                <div className="reserv-info">
                  <span>Reserva Telefónica</span>
                  <p><a href="tel:+573188959559" className="text-decoration-none">+57 318 895 9559</a></p>
                </div>
              </div>
            </div>
            <div className="sc1-imgs">
              <img src="/sec1.jpg" alt="" className="img1" />
            </div>
          </div>
        </section>
  )
}

export default Section1
